module.exports = "/_next/static/images/tn-f07a886c43903dd56aa47415935d7d27.svg";